import _implicitStylesheets from "./awardDeck.css";
import _implicitScopedStylesheets from "./awardDeck.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="award-deck__card${0}"${"s0"}${2}><img class="award-deck__image${0}"${"a1:src"}${"a1:alt"}${2}></div>`;
const stc0 = {
  "award-deck": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, k: api_key, sp: api_static_part, st: api_static_fragment, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": $cmp.viewAchievementsLabel
    },
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleActivate)),
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleKeydown))
    }
  }, api_iterator($cmp.positionedCards, function (card) {
    return api_static_fragment($fragment1, api_key(2, card.id), [api_static_part(0, {
      style: card.style
    }, null), api_static_part(1, {
      attrs: {
        "src": card.src,
        "alt": card.alt
      }
    }, null)]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6ocotb7vk8f";
tmpl.legacyStylesheetToken = "undefined-_awardDeck";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
